import createReducer from 'utils/createReducer';

// Constants
export const APP = 'app';

let INIT_STATE = {};
let reducers = {};

export const createReducerState = (newInitState, newReducers) => {
    INIT_STATE = {
        ...newInitState,
        ...INIT_STATE,
    };

    reducers = {
        ...newReducers,
        ...reducers,
    };

    return createReducer(INIT_STATE, reducers);
};

/**
 * Use it with componentInterfaceManager or DynamicReducer to register app modules
 *
 * Example with componentInterfaceManager:
 * import { combineModulesReducer, APP } from 'common/store';
 * import eventsModule from 'common/store/events';
 * import formsModule from 'common/store/forms';
 * ...
 * componentInterfaceManager.registerNamespace(APP, combineModulesReducer([eventsModule, formsModule]));
 *
 * @param {Array} modules
 */
export const combineModulesReducer = (modules) => {
    const { newInitState, newReducers } = modules.reduce(
        (prev, next) => ({
            newInitState: {
                ...prev.newInitState,
                ...next.initialState,
            },
            newReducers: {
                ...prev.newReducers,
                ...next.reducers,
            },
        }),
        {},
    );

    return createReducerState(newInitState, newReducers);
};

export default createReducerState;
